// 八字 · 十神与神煞简义
// 出处：《渊海子平·论十神》《三命通会·论十神》通行义理，
//       各家表述大同小异；此处采其通说，不取孤僻一说。

export const SHI_SHEN_MEANING = {
  比肩: '同我、同性者。如兄弟并行：主自立刚毅、重朋友情义，敢于分担；然比肩争财，亦主与人分利、父妻缘薄之虞。身弱遇之为助力，身强逢之多争竞。',
  劫财: '同我、异性者。如异姓手足：主豪爽义气、行动果决、善交际聚人；然劫财夺财，主钱财聚散无常、防破耗与感情争夺。身弱得之如雪中送炭，身强则防夺掠。',
  食神: '我所生、同性者。如亲儿顺育：主温和敦厚、口福寿相、才艺表达自然流露；为「寿星」「福星」，利饮食口才艺术行业。忌偏印（枭神）夺食。',
  伤官: '我所生、异性者。聪明外露、才华横溢而傲气：主创新变革、口舌锋利、不喜拘束；利技艺文名、自由行业，防恃才傲物、口舌官非。「伤官见官，为祸百端」之说指其与规矩权威易冲突。',
  偏财: '我所克、同性者。众人之财、流通之财：主慷慨豪爽、善经营交际，有意外之获、副业偏门之利；男命以之为父、为妾。财宜藏蓄，露则易散。',
  正财: '我所克、异性者。正职劳薪之财、养命之源：主勤俭踏实、守信持家，积少成多；男命以之为妻星。财星得位主富足安稳，被劫冲破则防劳而有失。',
  七杀: '克我、同性者。如强敌当面：主魄力威严、敢作敢当、执行力强；为「偏官」，武职权柄之星，逢制化（食神制杀、印化杀）则化为权，无制则伤身招祸、压力疾病缠身。',
  正官: '克我、异性者。如明礼约束：主端正守规、名誉地位、责任心强；为「禄神」，仕途管理之星，喜印护财佐。女命以之为夫星。官多反烂，怕伤官冲克。',
  偏印: '生我、同性者。如继母之荫，生中有隔：主领悟力强、精于玄学技艺数理、思虑深沉孤独；又称「枭神」，夺食则福薄，用之于学术宗教医卜则专长过人。',
  正印: '生我、异性者。如慈母庇佑：主聪慧仁慈、学识涵养、得长辈贵人提携；为文书、名誉、房产之星，利学术教育宗教。印重则倚赖心重、行动迟缓。',
  日主: '日干为自己，全局以它为基准论十神生克。日主宜中和：过强喜克泄耗，过弱喜生扶。',
};

export const SHENSHA_MEANING = {
  天乙贵人: '众煞之首，一生多贵人扶助；逢凶化吉，最利人际与机遇。',
  文昌贵人: '主聪明好学、文思敏捷；利考试、文书、艺术。',
  禄神: '食禄之位，主衣禄丰足、身体健康、事业根基。',
  羊刃: '刚烈锋刃，主权柄胆识；过刚易折，防伤病争斗（喜制化）。',
  驿马: '主动迁奔波、出行变动；马逢冲则动得更急，利外出谋生。',
  桃花: '主人缘魅力、情缘艺术；带合带贵为美，泛滥则烂桃花。',
  华盖: '艺术孤高之星，主聪慧宗教缘、喜玄学文艺；略主孤。',
  将星: '掌权之星，主领导组织能力；坐禄临旺更佳。',
  劫煞: '主劫夺波折、性急刚断；防意外破耗，喜吉星同宫化解。',
  灾煞: '主灾病伤灾、水火之厄；宜静守修身。',
  孤辰: '主性情孤僻、六亲缘薄；男忌孤辰。',
  寡宿: '主清冷独处、婚缘迟滞；女忌寡宿。',
  红鸾: '主婚姻喜庆、情缘萌动；逢流年引动多喜事。',
  天喜: '主喜庆添丁、逢凶化吉；与红鸾互为对冲。',
  空亡: '旬空之地，主其柱所代表之事虚而不实；吉神空则减力，凶煞空反吉。',
  魁罡: '日柱魁罡，主性格刚明果断、聪明权贵；女命魁罡貌美性刚。',
  天德贵人: '天之恩德庇佑：主心地善良、逢凶化吉，一生少大灾；女命得之尤主温良贤淑。',
  月德贵人: '月之恩德庇佑：主仁慈端方、做事有始有终；天月二德并见者，凶险大减、处世安泰。',
};

// 十二长生阶段义（《渊海子平》生死所论象义）
export const CHANGSHENG_MEANING = {
  长生: '如人之初生，气象一新：主开创、生机、新际遇。',
  沐浴: '如初生洗浴，裸形而露：主起伏不定、桃花风流、心境易变。',
  冠带: '如人加冠束带：主进取立业、名誉渐起、意气风发。',
  临官: '如人临官任职（进禄）：主事业得位、收入渐稳、实力兑现。',
  帝旺: '旺极之象：主力量鼎盛、大展宏图，亦防过刚易折。',
  衰: '由盛转衰：主守成积蓄、不宜冒进贪功。',
  病: '如人身病：主力有不逮，注意健康损耗，谋事宜缓。',
  死: '气机低沉：主静守修养，防消沉停滞。',
  墓: '如物入库存：主收藏积蓄、置产庇护，忌强出头。',
  绝: '气数断绝、将重来：旧事了断、另起炉灶之机。',
  胎: '如胎之成形：酝酿待机，宜谋划蓄势。',
  养: '如人之休养：渐进复苏、滋长根基。',
};

// ============================================================
// 白话版释义（零基础可读）＋ 宫位×十神组合义
// 宫位×十神参：《渊海子平》四柱六亲通例 ＋ 十神在各柱论断通行义
// ============================================================

export const PLAIN_SHI_SHEN = {
  比肩: '像你的兄弟姐妹／死党：帮你，也可能跟你抢东西。',
  劫财: '像讲义气的豪爽朋友：关键时刻拉你一把，也顺手花你的钱。',
  食神: '你的才华和福气：会吃、会玩、会表达，天生有口福。',
  伤官: '你的锋芒：聪明有创意、敢说敢怼，容易得罪人。',
  偏财: '活络的财：生意财、意外财，来得快去得也快。',
  正财: '工资财：踏实赚的稳定钱；男命还代表妻子。',
  七杀: '逼你成长的压力／强敌：扛得住就掌权，扛不住就受伤。',
  正官: '规矩与地位：领导、名誉、责任感；女命代表丈夫。',
  偏印: '非主流的智慧：直觉强、懂玄学技艺，但容易想太多。',
  正印: '妈妈般的庇护：学历、证书、贵人，是给你兜底的力量。',
  日主: '就是你自己。',
};

// 四柱宫位 × 十神：该神出现在哪一柱的传统论断（浓缩为一句）
export const PILLAR_GOD_MEANING = {
  正印: {
    年柱: '祖辈有文化德望，早年受长辈疼爱、家教重品德。',
    月柱: '得父母师长之力最厚，青年运顺、读书聪明（印绶在月令根基好）。',
    日柱: '配偶善良体贴、婚姻恩爱有助力。',
    时柱: '子女孝顺聪慧，晚年安泰有依靠。',
  },
  偏印: {
    年柱: '祖业较难依靠，或早年与长辈有些隔阂。',
    月柱: '青年期思虑多、学技艺快但易半途而废。',
    日柱: '配偶精明能干，但相处偏淡、有点距离感。',
    时柱: '子女缘偏晚或偏少，晚年喜欢清静独处。',
  },
  伤官: {
    年柱: '不继祖业、与双亲缘稍薄，早年多奔波。',
    月柱: '兄弟缘浅、青年才华外露，但也易招是非。',
    日柱: '配偶聪明伶俐但口舌较多，夫妻要多包容。',
    时柱: '子女聪明却难管教，晚年防操心孤独。',
  },
  食神: {
    年柱: '祖上有福荫，早年衣食无忧。',
    月柱: '青年口福才艺俱佳、性子和顺有贵人。',
    日柱: '配偶温和顾家，婚姻和美。',
    时柱: '晚年安逸享福，子女有出息。',
  },
  正官: {
    年柱: '出身规矩正经人家，早年守纪律，易承家业声望。',
    月柱: '青年得名望地位、考试仕途顺（官星坐提纲）。',
    日柱: '男得贤妻、女嫁良夫，婚姻稳定体面。',
    时柱: '晚年安稳有福，子女贤秀得力。',
  },
  七杀: {
    年柱: '早年环境压力大，或祖上有威严强势之人。',
    月柱: '青年竞争激烈、性格刚毅敢闯（若有印化杀更贵）。',
    日柱: '配偶强势能干，夫妻相处你需要退一步。',
    时柱: '晚年仍有威严操劳，子女刚强自立。',
  },
  正财: {
    年柱: '祖上经济观念强，早年家境小康。',
    月柱: '青年勤俭起家、财禄渐丰。',
    日柱: '男命妻贤内助、因妻得财；家庭财务稳固。',
    时柱: '晚年富足无忧，子女带财。',
  },
  偏财: {
    年柱: '祖上或有意外之财，早年家境随机会起伏。',
    月柱: '青年善交际理财，财来财去手面阔。',
    日柱: '配偶豪爽大方、人缘桃花旺。',
    时柱: '晚年财源不断，子女出手大方。',
  },
  比肩: {
    年柱: '多有兄弟姐妹，早年自立不太依赖家里。',
    月柱: '兄弟朋友助力大也会分利，青年多合作。',
    日柱: '配偶独立自主，婚姻平实需要经营。',
    时柱: '晚年有朋友子女相伴，平顺自在。',
  },
  劫财: {
    年柱: '早年家中或有破耗，与父亲缘分偏薄。',
    月柱: '青年易意气用事破财，防兄弟朋友争利。',
    日柱: '配偶能干强势，钱财往来要分明。',
    时柱: '晚年防破耗，子女开销较大。',
  },
};

// 纳音说明（通用义，不作吉凶定论）
export const NAYIN_NOTE = '纳音是把六十甲子两两一组、配成三十个「音律五行」标签的古法（如两人同属「海中金」）。唐宋以前以年柱纳音论命为主；现代子平法以正五行为主、纳音作性格意象的辅助参考。名字本身即意象：如「海中金」＝金气沉在大海深处——内敛深藏之金。';
